<template>
  <div class="e-selector-tip__placeholder" ref="tipPlaceholder" :style="{height: height }">
    <div class="e-selector-tip" :class="{'e-selector-tip--relative': relative}" v-html="text" ref="tip" />
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    text: {
      type: String,
      required: true,
    },
    relative: {
      type: Boolean,
      default: false,
    },
  },
  name: 'Tip',
  data() {
    return {
      height: 'auto',
    };
  },
  mounted() {
    if (!this.relative) {
      this.calcTip();
      window.addEventListener('resize', this.calcTip);
    }
  },
  methods: {
    calcTip() {
      const h = this.$refs.tip?.getBoundingClientRect()?.height || 0;
      this.height = `${h}px`;
    },
  },
};
</script>

<style lang="scss">
</style>
